import {
  CricketSubParticipantStatId,
  EventsLineupsParticipant,
  SubParticipant,
} from '@collector/sportsapi-client-legacy'
import { UpdateEventSubParticipantsDTO } from '@mobile/ActionQueue/Actions/Event/UpdateEventSubParticipants'

export function findLineupSubParticipantBasedOnStat(
  statId: number,
  eventSubParticipants: SubParticipant[],
  lineups: EventsLineupsParticipant[],
): EventsLineupsParticipant | undefined {
  const eventSubParticipant = eventSubParticipants.find((subParticipant) =>
    subParticipant.stats?.some(
      (stat) => stat.id === statId && stat.value === 1,
    ),
  )

  return lineups.find(
    (player) => player.participant_id === eventSubParticipant?.id,
  )
}

export function findLineupSubParticipantBasedOnId(
  participantId: number,
  lineups: EventsLineupsParticipant[],
): EventsLineupsParticipant | undefined {
  return lineups.find((player) => player.participant_id === participantId)
}

export function prepareUpdateEventSubParticipantsPayload(
  relevantStatId: CricketSubParticipantStatId,
  participantId: number | null,
  lineups: EventsLineupsParticipant[],
): UpdateEventSubParticipantsDTO {
  const payload: UpdateEventSubParticipantsDTO = []

  lineups.forEach((player) => {
    const isCurrentParticipant = player.participant_id === participantId

    payload.push({
      id: player.participant_id,
      team_id: player.participant_team_id,
      stats: [
        {
          id: relevantStatId,
          value: isCurrentParticipant ? 1 : 0,
        },
        {
          id:
            relevantStatId === CricketSubParticipantStatId.CurrentBatter
              ? CricketSubParticipantStatId.CurrentBowler
              : CricketSubParticipantStatId.CurrentBatter,
          value: 0,
        },
      ],
    })
  })

  return payload
}
